module.exports = __webpack_public_path__ + "img/left.90f38527.svg";